import { DatePipe } from "@angular/common";
import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import * as fileSaver from "file-saver";
import { OverlayPanel } from "primeng/overlaypanel";
import { GLOBAL_CONSTANT } from "../../common/constant/global.constant";
import { DebounceService } from 'src/app/services/debounce.service';

import { UtilityService } from "../../../app/shared/utility.service";
import { SessionService } from "../../common/services/session.service";
import { locationBinderInterface } from "../../shared/component/location-binder/location-binder.interface";
import { ComplaintService } from "../complaint-service/api/complaint.service";

@Component({
  selector: "app-complaint-report",
  templateUrl: "./complaint-report.component.html",
  styleUrls: ["./complaint-report.component.scss"],
})
export class ComplaintReportComponent implements OnInit {
  @ViewChild("filter", { static: false }) filter: OverlayPanel;

  locationBinderObj: locationBinderInterface;

  status: string = "UNSOLVED";
  officeName: string;
  complaints: Array<any>;
  officeData: any;
  userInfo: any;
  netaFlag: boolean = false;
  complainData: {
    unsolved: any;
    hold: any;
    inProgress: any;
    solved: any;
    queue: any;
  };
  allCount: Array<any>;
  unsolvedCount: number;
  holdCount: number;
  inProgressCount: number;
  solvedCount: number;
  queueCount: number;
  statusUpdateCount: number;
  index: any;
  parentSearchkey = "";

  categoryData: Array<any>;
  flagDate:Array<any>;
  selectedCategory: any;
  selectedFlag:any;
  cTypeData: Array<any>;
  selectedCType: any;
  checked: boolean = false;
  filterObj: any;
  dateFrom: Date;
  dateTo: Date;
  filterObject: any;
  filterFlag: boolean = false;
  karyakartaFilterFlag: boolean = true;
  adminflag: boolean = false;
  isActionAllowed: boolean = false;
  complainObj: any;
  defaultPage: any;
  page: any;
  size: any;
  yearRange: string;
  excelPopupVisible: boolean = false;
  availableFields: any[] = []; // Fields from API
  selectedFields: any[] ; // User-selected fields
  selectAll: boolean = false;
  constructor(
    private complaintService: ComplaintService,
    private sessionService: SessionService,
    private router: Router,
    private utility: UtilityService,
    private datePipe: DatePipe,
    private us: UtilityService,
    private debounceService: DebounceService
  ) {
    this.defaultPage = {
      page: {
        number: 0,
        size: this.size,
      },
    };
    this.clearFilter();
    this.locationBinderObj = {};
    this.yearRange = this.us.CalYearRange();
  }

  clearFilter() {
    this.filterObj = {
      category: undefined,
      type: undefined,
      dateFrom: undefined,
      dateTo: undefined,
      kiosk: false,
      page: this.page,
      search: undefined,
      flag:undefined
    };
    this.filterObject = {
      category: undefined,
      type: undefined,
      dateFrom: undefined,
      dateTo: undefined,
      kiosk: false,
      page: this.page,
    };
    this.dateFrom = undefined;
    this.dateTo = undefined;
    this.selectedCType = undefined;
    this.selectedCategory = undefined;
    this.locationBinderObj = {};
    this.selectedFlag = undefined;
    this.searchTerm = '';
  }

  setFilterObject() {
    this.clearFilter();
    this.filterFlag = false;
  }
  Filter(event, overlaypanel: OverlayPanel) {
    overlaypanel.toggle(event);
  }
  


  getCounts($event: any) {
    if ($event.index === "0") {
      this.unsolvedCount = $event.count;
    }
    if ($event.index === "1") {
      this.inProgressCount = $event.count;
    }
    if ($event.index === "2") {
      this.solvedCount = $event.count;
    }
    if ($event.index === "3") {
      this.holdCount = $event.count;
    }
    if ($event.index === "4") {
      this.queueCount = $event.count;
    }
    if ($event.index === "5") {
      this.statusUpdateCount = $event.count;
    }
  }

  // filter Methods
  getCategoryList() {
    this.complaintService.getCategoryData().subscribe((ele: any) => {
      this.categoryData = ele;
    });
  }
  on_Change_Category() {
    let selectedCategoryId = this.selectedCategory["id"];
    this.getComplaintTypeList(selectedCategoryId);
  }

  getComplaintTypeList(selectedCategoryId) {
    this.categoryData.forEach((element) => {
      if (element.id == selectedCategoryId) {
        this.cTypeData = element.types;
      }
    });
  }

  onLazyLoad($event) {
    this.page = this.us.PaginationPerPage($event);
    this.defaultPage.page.size = $event.rows;
  }


  searchTerm: string = '';
  isLoading: boolean = false;

  onSearchInputChange(event: any) {
      
    this.searchTerm = event.target.value;

    if (this.searchTerm.length < 2) {
      return;
    }
  
    this.debounceService.triggerSearch(this.searchTerm);
  }
  

  handelSubmit(search:string) {

    this.isLoading=true;
    this.filterObj.search = search;
    this.filterFlag = true;
    this.filterObj = Object.assign(this.filterObj, this.locationBinderObj);
    if (this.selectedCategory != undefined) {
      this.filterObj.category = this.selectedCategory;
    } else {
      this.filterObj.category = null;
    }
    if (this.selectedCType != undefined) {
      this.filterObj.type = this.selectedCType;
    } else {
      this.filterObj.type = null;
    }
    if (this.page !== undefined) {
      this.filterObj.page = this.page;
    } else {
      this.filterObj.page = this.defaultPage;
    }
    if (this.selectedFlag !== undefined) {
      this.filterObj.flag = this.selectedFlag;
    } else {
      this.filterObj.flag = null;
    }

    if (this.dateFrom !== undefined) {
      let date = this.dateFrom;
      let d = date.getDate();
      let m = date.getMonth() + 1;
      let y = date.getFullYear();
      this.filterObj.dateFrom =
        y + "-" + (m <= 9 ? "0" + m : m) + "-" + (d <= 9 ? "0" + d : d);
    } else {
      this.filterObj.dateFrom = "";
    }

    if (this.dateTo !== undefined) {
      let date1 = this.dateTo;
      let d1 = date1.getDate();
      let m1 = date1.getMonth() + 1;
      let y1 = date1.getFullYear();
      this.filterObj.dateTo =
        y1 + "-" + (m1 <= 9 ? "0" + m1 : m1) + "-" + (d1 <= 9 ? "0" + d1 : d1);
    } else {
      this.filterObj.dateTo = "";
    }

    let ccc = JSON.parse(JSON.stringify(this.filterObj));
    this.filterObject = ccc;
    this.filter.hide();
    this.isLoading=false;
  }

  getIndexForStatus(index: number) {
    switch (index) {
      case 0:
        this.status = "UNSOLVED";
        break;
      case 1:
        this.status = "INPROGRESS";
        break;
      case 2:
        this.status = "SOLVED";
        break;
      case 3:
        this.status = "HOLD";
        break;
      case 4:
        this.status = "QUEUE";
        break;
      case 5:
        this.status = "STATUSUPDATEREQUESTED";
        break;
    }
  }
  // download file

  // downloadFile() {
  //   this.complaintService.getCSV(this.filterObject).subscribe((res) => {
  //     var blob = new Blob([res], { type: "text/plain;charset=utf-8" });
  //     fileSaver.saveAs(blob, "Complaint.csv");
  //   });
  // }

  ngOnInit() {
    this.isLoading=false;
    this.flagDate = GLOBAL_CONSTANT.FLAG_DATE;
    this.getCategoryList();
    

    this.userInfo = this.sessionService.getUserInfo();
    if (this.router.url && this.router.url.indexOf("/complain/list") > -1) {
      this.isActionAllowed = true;
    }
    if (this.userInfo.role == "SUPER_ADMIN") {
      this.adminflag = true;
    }
    if (this.userInfo.role == "VIEWER") {
      this.netaFlag = true;
      this.officeData = true;
    } else {
      this.officeData = this.sessionService.getOffice();
    }
    if (this.userInfo.role === "KARYA_KARTA") {
      this.karyakartaFilterFlag = false;
    }

    
       // Listen for search input and call API after debounce
  this.debounceService.search$.subscribe(search => {
    this.handelSubmit(search);
  });

  // Listen for loader state
  this.debounceService.loading$.subscribe(state => {
    this.isLoading = state;
  });
    
  }
  
  ngOnDestroy() {
    this.debounceService.setLoading(false); 
  }

 
  toggleSelectAll() {
    this.availableFields.forEach(field => {
      field.selected = this.selectAll;
    });
  }
  
  // Open popup
  openExcelPopup() {
  
   this.complaintService.getExcelFields().subscribe((res: any) => {
     console.log('res',res);
     this.availableFields = res.map(field => ({
       ...field, // Assuming API returns displayName
       value: field.value, // Assuming API returns field name
       selected: field.isPreload
     }));
     this.excelPopupVisible = true;
   });
   
   
  }
  
  // Collect selected fields and download Excel
  downloadSelectedFields() {
   const selectedFields = this.availableFields
     .filter(field => field.selected) // Only selected fields
     .map(({ label, value }) => ({ label, value , default: "--"})); // Sending correct format
  
   console.log('Selected Fields Sent to API:', selectedFields);
  
   if (selectedFields.length === 0) {
     alert('Please select at least one field.');
     return;
   }
   console.log('Sent to API:', selectedFields); 
   const requestPayload = {
     selectedFields: selectedFields // Sending array inside an object
   }; 
   // Ensure we're sending the correctly filtered fields
   this.complaintService.getCSV(requestPayload).subscribe((res) => {
     console.log('CSV Response:', res);
     
     var blob = new Blob([res], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
     fileSaver.saveAs(blob, "Complaint Book.csv");
   });
  
   this.excelPopupVisible = false;
  }
}

